import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ClientBrief.scss';export default {
  "ClientBrief": "_ClientBrief_uneyf_1"
};